import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined';

// Helper function to safely get environment variables
const getEnvVar = (key, defaultValue = '') => {
  if (typeof process !== 'undefined' && process && process.env) {
    const value = process.env[key];
    return value || defaultValue;
  } else {
    return defaultValue;
  }
};

// Helper function to validate Firebase URL
const validateFirebaseURL = (url) => {
  if (!url || url === 'your-database-url') {
    return null;
  }
  
  // Ensure URL starts with https://
  if (!url.startsWith('https://')) {
    return null;
  }
  
  // Ensure URL ends with firebaseio.com
  if (!url.includes('firebaseio.com')) {
    return null;
  }
  
  return url;
};

const firebaseConfig = {
  apiKey: getEnvVar('REACT_APP_FIREBASE_API_KEY') || "your-api-key",
  authDomain: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN') || "your-auth-domain",
  databaseURL: validateFirebaseURL(getEnvVar('REACT_APP_FIREBASE_DATABASE_URL')),
  projectId: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID') || "your-project-id",
  storageBucket: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET') || "your-storage-bucket",
  messagingSenderId: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID') || "your-messaging-sender-id",
  appId: getEnvVar('REACT_APP_FIREBASE_APP_ID') || "your-app-id"
};

// Validate configuration
const validConfig = firebaseConfig.databaseURL && 
                   firebaseConfig.apiKey !== 'your-api-key' && 
                   firebaseConfig.projectId !== 'your-project-id';

// Initialize Firebase only if config is valid
let firebaseApp = null;

try {
  if (!firebase.apps.length) {
    // Only initialize if we have a valid database URL
    if (firebaseConfig.databaseURL) {
      firebaseApp = firebase.initializeApp(firebaseConfig);
    }
  } else {
    firebaseApp = firebase.apps[0];
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Configure Firebase for production only if successfully initialized
if (firebaseApp) {
  try {
    // Configure storage for better performance
    firebase.storage().setMaxUploadRetryTime(60000); // 60 seconds
    firebase.storage().setMaxOperationRetryTime(60000); // 60 seconds
  } catch (error) {
    console.error('Firebase production configuration error:', error);
  }
}

// Export configured Firebase instance
export default firebase;

// Export individual services for convenience (with error handling)
export const auth = firebaseApp ? firebase.auth() : null;
export const database = firebaseApp ? firebase.database() : null;
export const storage = firebaseApp ? firebase.storage() : null;
